import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/lib/redux/store';

export const selectModalsSlice = (state: RootState) => state.modals;

export const selectOpenModals = createSelector(
  selectModalsSlice,
  (substate) => substate.openModals
);
